import React from "react";

export function RichTextContent(props) {
    return <p className="mt-2 drawer__body"
              style={{color: '#121212', lineHeight: '170%', letterSpacing: '-0.5%', fontSize: '14px'}}
              dangerouslySetInnerHTML={{__html: props.html}}/>;
}